module.exports = __webpack_public_path__ + "img/Villa_Borna_18.5a193477.jpg";